<template>
   <div>
      <Slider style="margin-top:4rem;"/>
      <Section/>
   </div>
</template>
<script>
import Slider from "../components/Slider.vue";
import Section from "../components/Section.vue";

  export default {
   components:{
      Slider,
      Section,
   },
   
  }
</script>

